
//判断权限指令
function getPerm (value) {
  // console.log(value);
  let data = [];
  let permissions = null;
  if (!localStorage.getItem("permissionsKeyObj")) { // permissionsKeyObj 代表当前key的value
    permissions = JSON.parse(localStorage.getItem("permissions"));
    if (permissions && permissions.hasOwnProperty(value.key)) {
      data = permissions[value.key]
    }
    localStorage.setItem('permissionsKeyObj', JSON.stringify({key: value.key, list: data}))
  } else {
    let permissionsKeyObj =  JSON.parse(localStorage.getItem("permissionsKeyObj"))
    if (permissionsKeyObj.key === value.key) {
      data = permissionsKeyObj.list
    } else {
      permissions = JSON.parse(localStorage.getItem("permissions"));
      if (permissions && permissions.hasOwnProperty(value.key)) {
        data = permissions[value.key]
      }
      localStorage.setItem('permissionsKeyObj', JSON.stringify({key: value.key, list: data}))
    }
  }
  if (!data || data == 'undefined' || data.length == 0) return false;
  const permissionsKey = data || {};
  let num = permissionsKey.findIndex(item => item === value.value)
  return num > -1 ? true:false;
}

export default {
    perm: {
        inserted: function(el, binding) {
        const value = binding.value;
            if (!getPerm(value)) {
              el.remove(); // 设置为不可用
              el.style.cursor = "not-allowed";
            }
        },
        // inserted: function(el, binding) {
        //     const value = binding.value;
        //     if (!getPerm(value)) {
        //         el.parentNode.removeChild(el);   // 移除按钮
        //     }
        //   },
    }
}